import './unpaid-invoices.scss';
import React from 'react';
import _ from 'lodash';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { convertedPrice } from 'researcher/helpers/price';
var MAX_UNPAID_INVOICES_TO_DISPLAY = 10;
var UnpaidInvoices = function UnpaidInvoices(_ref) {
  var currency = _ref.currency,
    unpaidInvoices = _ref.unpaidInvoices,
    hideInvoices = _ref.hideInvoices;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (hideInvoices || Object.keys(unpaidInvoices).length === 0) {
    return null;
  }
  var balance = _.reduce(unpaidInvoices, function (carry, invoice) {
    return carry + invoice.balance;
  }, 0);
  var unpaidInvoiceCount = _.size(unpaidInvoices);
  return /*#__PURE__*/React.createElement("div", {
    className: "row unpaid-invoices"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-primary btn-large float-end",
    to: "/researcher/invoices/unpaid"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Pay Now"
  })), /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(T, {
    source: "You have %1$s unpaid invoices totaling %3$s%2$.2f",
    params: [unpaidInvoiceCount, convertedPrice(currency, balance, false) % 1 === 0 ? convertedPrice(currency, balance, false) : convertedPrice(currency, balance, false).toFixed(2), currency.sign]
  })), unpaidInvoiceCount <= MAX_UNPAID_INVOICES_TO_DISPLAY ? /*#__PURE__*/React.createElement("ul", null, _.map(unpaidInvoices, function (unpaidInvoice) {
    return /*#__PURE__*/React.createElement("li", {
      key: unpaidInvoice.invoiceNumber
    }, /*#__PURE__*/React.createElement(T, {
      source: "unpaid-invoices",
      params: {
        invoiceNumber: "(".concat(unpaidInvoice.invoiceNumber, ")"),
        formattedDate: unpaidInvoice.formattedDate,
        convertedPrice: convertedPrice(currency, unpaidInvoice.balance) % 1 === 0 ? convertedPrice(currency, unpaidInvoice.balance) : convertedPrice(currency, unpaidInvoice.balance).toFixed(2),
        currency: currency.sign
      }
    }), "\u2014", /*#__PURE__*/React.createElement("a", {
      "aria-label": t('View Invoice'),
      href: "/api/invoice/".concat(unpaidInvoice.invoiceNumber, "/pdf")
    }, /*#__PURE__*/React.createElement(T, {
      source: "View Invoice"
    })));
  })) : null)));
};
export default UnpaidInvoices;